import React, { useCallback, useEffect, useState } from 'react';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import omit from 'lodash.omit';
import NameListTableData from './NameListTableData';
import generalRouteSubRouteService from '@rd-web-markets/shared/dist/services/general_route_subroute.service';
import nameListsService from '../../../services/elster/namelist.service';
const notSavedStyle = {
  borderLeft: '5px solid red'
};
const NameListRow = _ref => {
  let {
    data,
    setData,
    rowData,
    selectedProject,
    emptyRowId = null,
    removeEmptyRow,
    showHalfYearColumn,
    elsterYearForStaffCost
  } = _ref;
  const {
    uploadAllowed,
    body,
    uploadFile,
    saveData,
    createNewData,
    deleteData,
    isSaved,
    setBody,
    setUploadAllowed
  } = nameListsService.useCrud(rowData, selectedProject, data, setData, removeEmptyRow, emptyRowId);
  return /*#__PURE__*/React.createElement("tr", {
    className: rowData.id ? '' : 'newRow'
  }, /*#__PURE__*/React.createElement(NameListTableData, {
    isSaved: isSaved,
    notSavedStyle: notSavedStyle,
    body: body,
    setBody: setBody,
    saveData: saveData,
    deleteData: deleteData,
    data: data,
    rowData: rowData,
    uploadFile: uploadFile,
    uploadAllowed: uploadAllowed,
    setUploadAllowed: setUploadAllowed,
    createNewData: createNewData,
    removeEmptyRow: removeEmptyRow,
    emptyRowId: emptyRowId,
    showHalfYearColumn: showHalfYearColumn,
    elsterYearForStaffCost: elsterYearForStaffCost
  }));
};
export default NameListRow;